<template>
  <div class="fourPage">
    <template>
      <div class="headline">1.项目有效期</div>
      <el-form ref="form" :model="fourpageData" label-width="140px" size="small">
        <el-form-item label="项目上线时间">
          <el-radio-group v-model="fourpageData.onlineTime.radio">
            <el-radio label="审核通过后立即上线"></el-radio>
            <el-radio label="指定上线时间"></el-radio>
          </el-radio-group>
          <el-input v-model="fourpageData.onlineTime.time" placeholder="请输入内容" class="width220" size="small"></el-input>
        </el-form-item>

        <el-form-item label="代金券有效期" v-if="type==2">
          <el-radio-group v-model="fourpageData.voucherValidity.radio">
            <!-- <el-radio v-model="radio" label="1">备选项</el-radio> -->
            <el-radio label="自上线之日起."></el-radio>
            <el-input v-model="fourpageData.voucherValidity.month" placeholder="请输入内容" class="width130-lft" size="small">
              <template slot="append">个月</template>
            </el-input>
            <br />
            <el-radio label="自上线之日起,"></el-radio>
            <el-input v-model="fourpageData.voucherValidity.day" placeholder="请输入内容" class="width130-lft" size="small">
              <template slot="append">天</template>
            </el-input>
            <br />
            <el-radio label="自上线之日起'"></el-radio>
            <el-input v-model="fourpageData.voucherValidity.hour" placeholder="请输入内容" class="width130-lft" size="small">
              <template slot="append">小时</template>
            </el-input>
            <br />
          </el-radio-group>
          <div class="hint">团购券有效期是指可接待团购用户的有效期限</div>
        </el-form-item>

        <el-form-item label="不可用日期">
          <el-radio-group v-model="fourpageData.downTime">
            <el-radio label="所有日期都可使用"></el-radio>
            <el-radio label="部分日期不可使用"></el-radio>
          </el-radio-group>
          <div class="hint">选择“部分日期不可使用”时，请使用日历控件设置具体的不可用日期</div>
        </el-form-item>

        <el-form-item label="是否支持自动延长代金券有效期">
          <el-radio-group v-model="fourpageData.whetherProlong">
            <el-radio label="是，默认每次延期30天"></el-radio>
            <el-radio label="否，不支持"></el-radio>
          </el-radio-group>
          <div class="hint">提示：当您选择“是”的时候，系统将默认每30天自动延期：如选择“否”则该项目不会自动延期，如要延期只能手动延期</div>
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">2.消费时间</div>
      <el-form ref="form" :model="fourpageData" label-width="140px" size="small">
        <el-form-item label="使用时间">
          <el-radio-group v-model="fourpageData.UseHours.radio">
            <el-radio label="24小时使用"></el-radio>
            <el-radio label="部分时间可使用"></el-radio>
          </el-radio-group>
          <div class>
            <span>指定可用时间：</span>
            <el-input v-model="fourpageData.UseHours.startHour" placeholder="请输入内容" class="width130" size="small">
              <template slot="append">点</template>
            </el-input>
            <el-input v-model="fourpageData.UseHours.startMinute" placeholder="请输入内容" class="width130" size="small">
              <template slot="append">分</template>
            </el-input>至
            <el-input v-model="fourpageData.UseHours.endHour" placeholder="请输入内容" class="width130" size="small">
              <template slot="append">点</template>
            </el-input>
            <el-input v-model="fourpageData.UseHours.endMinute" placeholder="请输入内容" class="width130" size="small">
              <template slot="append">分</template>
            </el-input>
          </div>
          <!-- <el-button type="text">添加</el-button> -->
          <div class>
            <span>特殊情况说明：</span>
            <el-input v-model="fourpageData.UseHours.explain" placeholder="请输入内容" class="width220" size="small"></el-input>
          </div>
          <div class="hint">提示：指定可用时间不能为空</div>
        </el-form-item>

        <el-form-item label="是否预约">
          <el-radio-group v-model="fourpageData.ifAppointment.radio">
            <el-radio label="无需预约，消费高峰时可能需要等位"></el-radio>
            <el-radio label="其他："></el-radio>
          </el-radio-group>
          <el-input v-model="fourpageData.ifAppointment.input" placeholder="请输入内容" class="width220" size="small"></el-input>
          <div class="hint">团购券有效期是指可接待团购用户的有效期限</div>
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">3.团购约定</div>

      <el-form ref="form" :model="fourpageData" label-width="140px" size="small">
        <template v-if="type == 2">
        <el-form-item label="每人最多买几张">
          <el-radio-group v-model="fourpageData.aFewPer.radio">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">是，每人限购</el-radio>
          </el-radio-group>
          <el-input v-model="fourpageData.aFewPer.input" placeholder="请输入内容" class="width130" size="small">
            <template slot="append">张</template>
          </el-input>
        </el-form-item>

        <el-form-item label="每人每天最多买几张">
          <el-radio-group v-model="fourpageData.aFewPerDay.radio">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">是，每人每天限购</el-radio>
          </el-radio-group>
          <el-input v-model="fourpageData.aFewPerDay.input" placeholder="请输入内容" class="width130" size="small">
            <template slot="append">张</template>
          </el-input>
        </el-form-item>

        <el-form-item label="是否限用代金券">
          <el-radio-group v-model="fourpageData.limitUseReel.radio">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">限，每人限用</el-radio>
          </el-radio-group>
          <el-input v-model="fourpageData.limitUseReel.input" placeholder="请输入内容" class="width130" size="small">
            <template slot="append">张券</template>
          </el-input>
        </el-form-item>

        <el-form-item label="每张券最多可几人使用">
          <el-radio-group v-model="fourpageData.reelMaxUse.radio">
            <el-radio label="1">不限</el-radio>
            <el-radio label="2">限，每张限</el-radio>
          </el-radio-group>
          <el-input v-model="fourpageData.reelMaxUse.user" placeholder="请输入内容" class="width220" size="small">
            <template slot="append">人使用，身高</template>
          </el-input>
          <el-input v-model="fourpageData.reelMaxUse.num" placeholder="请输入内容" class="width220" size="small">
            <template slot="append">米以上儿童计入人数</template>
          </el-input>
        </el-form-item>
        </template>
        <!-- <el-form-item label="是否支持V3及以下等级用户极速退">
          <el-radio-group v-model="fourpageData.resource">
            <el-radio label="支持"></el-radio>
            <el-radio label="不支持"></el-radio>
          </el-radio-group>
          <div class="hint">提示：极速退是指消费者申请退款后可以立即到账；为了更好的保障消费者权益，建议您选择支持，并在用户消费后及时验证团购券</div>
        </el-form-item> -->

        <el-form-item label="是否提供发票">
          <el-radio-group v-model="fourpageData.ifInvoice.radio">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
          <div class="hint">1.选择“是”则在购买须知中增加如“本单发票由商家提供，请在消费时向商家索取”字样</div>
          <div class="hint">1.2.展示发票信息，更多曝光机会，更多销量</div>
          <div class="hint">1.3.商家有为消费者提供发票的义务</div>
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">4.商家服务</div>
      <el-form ref="form" :model="fourpageData" label-width="140px" size="small">
        <el-form-item label="WIFi服务">
          <el-radio-group v-model="fourpageData.ifWifi.radio">
            <el-radio label="1">无</el-radio>
            <el-radio label="2">免费</el-radio>
            <el-radio label="3">收费</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="停车位收费标准">
          <el-radio-group v-model="fourpageData.ifStopCharge.radio">
            <el-radio label="1">免费，提供</el-radio>
            <el-input v-model="fourpageData.ifStopCharge.noMoney" placeholder="请输入内容" class="width130-lft" size="small">
              <template slot="append">个停车位</template>
            </el-input>
            <br />
            <el-radio label="2">收费</el-radio>
            <el-input v-model="fourpageData.ifStopCharge.chargeTime" placeholder="请输入内容" class="width130-lft" size="small">
              <template slot="append">元/小时</template>
            </el-input>
            <el-input v-model="fourpageData.ifStopCharge.chargeNum" placeholder="请输入内容" class="width220" size="small">
              <template slot="prepend">提供</template>
              <template slot="append">个停车位</template>
            </el-input>
            <br />
            <el-radio label="3">无停车位</el-radio>
            <el-input v-model="fourpageData.ifStopCharge.noStop" placeholder="请输入内容" class="width130-lft" size="small">
              <template slot="append">小时</template>
            </el-input>
            <br />
            <el-radio label="4">其他</el-radio>
            <el-input v-model="fourpageData.ifStopCharge.input" placeholder="请输入内容" class="width220" size="small">
            </el-input>
            <br />
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否可以享受其他优惠">
          <el-radio-group v-model="fourpageData.ifItdiscounts.radio">
            <el-radio label="1">不可以</el-radio>
            <br />
            <el-radio label="2">是，可以享受其他所有优惠</el-radio>
            <br />
            <el-radio label="3">是，但只能享受的优惠为</el-radio>
            <el-input v-model="fourpageData.ifItdiscounts.input" placeholder="请输入内容" class="width220-lft" size="small">
            </el-input>
            <br />
          </el-radio-group>
        </el-form-item>
      </el-form>
    </template>
    <div class="headline">5.其他补充条款</div>
    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea"></el-input>
  </div>
</template>

<script>
export default {
  props:["type"],
  data() {
    return {
      fourpageData: {
        onlineTime: {
          //项目上线时间
          radio: "审核通过后立即上线",
          time: ""
        },
        voucherValidity: {
          // 代金券有效期
          radio: "自上线之日起.",
          month: "",
          day: "",
          hour: ""
        },
        downTime: "所有日期都可使用", // 不可用日期
        whetherProlong: "是，默认每次延期30天", // 是否支持自动延长代金券有效期
        UseHours: {//使用时间
          radio: "24小时使用",
          startHour: "",
          startMinute: "",
          endHour: "",
          endMinute: "",
          explain: ""
        },
        ifAppointment: {//是否预约
          radio: "无需预约，消费高峰时可能需要等位",
          input: ""
        },
        aFewPer: {
          // 每人最多买几张
          radio: "1",
          input: ""
        },
        aFewPerDay: {
          // 每人每天最多买几张
          radio: "1",
          input: ""
        },
        limitUseReel: {
          // 是否限用代金券
          radio: "1",
          input: ""
        },
        reelMaxUse: {
          // 每张券最多可几人使用
          radio: "1",
          user: "",
          num: ""
        },
        ifInvoice: {
          // 是否开发票
          radio: "1"
        },
        ifWifi: {
          radio: "1"
        },
        ifStopCharge: {
          // 停车位收费标准
          radio: "1",
          noMoney: "",
          chargeTime: "",
          chargeNum: "",
          noStop: "",
          input: ""
        },
        ifItdiscounts: {
          // 是否可以享受其他优惠
          radio: "1",
          input: ""
        },
        OtherTerms: "" //其他补充条款
      },
      textarea: "",
      tableData: []
    };
  },
  mounted() {
    console.log(this.itemClass);
  }
};
</script>

<style lang="scss" scoped>
.fourPage {
  .headline {
    margin: 20px 0px;
    font-size: 16px;
    font-weight: 600;
  }
  .hint {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  .el-radio-group {
    line-height: 42px;
  }
  .width220 {
    margin: 0 5px;
    width: 220px;
  }
  .width220-lft {
    margin: 0 5px;
    width: 220px;
    margin-left: -20px;
  }
  .width130 {
    margin: 0 5px;
    width: 130px;
    padding-bottom: 10px;
  }
  .width130-lft {
    margin: 0 5px;
    width: 130px;
    margin-left: -20px;
    padding-bottom: 10px;
  }
}
</style>

<style lang="scss">
.fourPage {
  .cell {
    text-align: center;
  }
  .el-input-group__append {
    padding: 0 10px;
  }
}
</style>
